// noinspection JSValidateTypes

import {Basic} from "./Basic";
import {History} from "./History";
import {Load} from "./Load";
import {Modal} from "./Modal";

export class Cart
{
    constructor()
    {
        this.cartExtras = localStorage.getItem("extras") ? JSON.parse(localStorage.getItem("extras")) : {};
        this.cartItems = localStorage.getItem("cart") ? JSON.parse(localStorage.getItem("cart")) : [];
        this.cartIcon = document.body.querySelector(".w__nav .w__button.mod--cart");
    }

    add_product(page, key)
    {
        let total = 0,
            quantity = 1;
        const myVariant = page.querySelector('.w__input--radio[name="variant"]:checked'),
              myOption = page.querySelector('.w__input--radio[name="option"]:checked'),
              myExtras = page.querySelectorAll('.w__input--checkbox:checked'),
              myImage = (myVariant.dataset.imageSrc
                  ? myVariant.dataset.imageSrc
                  : page.querySelector('.w__product--section.mod--header .w__tile--image').dataset.originalSrc),
              sublabel = page.querySelector('.w__product--subtitle');

        if(key === undefined)
        {
            key = this.cartItems.length;
        }
        else
        {
            quantity = this.cartItems[key].quantity;
        }

        total += parseFloat(myVariant.dataset.price);

        this.cartItems[key] = {
            id: parseInt(page.dataset.productId),
            imageSrc: myImage,
            label: page.querySelector('.w__product--title').textContent,
            sublabel: sublabel ? sublabel.textContent : '',
            leadTime: parseInt(page.dataset.leadTime),
            variantId: parseInt(myVariant.value),
            variantLabel: myVariant.nextElementSibling.textContent,
            variantPrice: parseFloat(myVariant.dataset.price),
            weight: parseFloat(myVariant.dataset.weight),
            quantity: quantity,
            requireImage: (page.dataset.requireImage === "1"),
            uploadedImageSrc: this.cartItems[key] ? this.cartItems[key].uploadedImageSrc : '',
            uploadedThumbSrc: this.cartItems[key] ? this.cartItems[key].uploadedThumbSrc : ''
        };

        if(myOption)
        {
            total += parseFloat(myOption.dataset.price);
            this.cartItems[key].optionId = parseInt(myOption.value);
            this.cartItems[key].optionLabel = myOption.nextElementSibling.textContent;
            this.cartItems[key].optionPrice = parseFloat(myOption.dataset.price);
        }

        if(myExtras.length)
        {
            this.cartItems[key].extras = [];
            let i = 0;

            myExtras.forEach(extra => {
                const extraContainer = extra.closest('.w__product--option');
                total += parseFloat(extra.dataset.price);

                this.cartItems[key].extras[i] = {
                    id: parseInt(extra.value),
                    label: extra.nextElementSibling.textContent,
                    price: parseFloat(extra.dataset.price)
                };

                if(parseInt(extra.dataset.textLength))
                {
                    this.cartItems[key].extras[i].text = extraContainer.querySelector('.w__input.w__input--text').value.trim();
                }

                const extraImage = extraContainer.querySelector('.w__product--extra-image');
                if(extraImage)
                {
                    this.cartItems[key].extras[i].imageSrc = extraImage.dataset.imageSrc;
                }

                i++;
            });
        }

        this.cartItems[key].total = total;
        this.update_session();
        this.display_cart(true);
    }

    check_validity(send, cartKey)
    {
        const page = document.body.querySelector('.w__module.mod--cart');
        let status = false;

        if(page)
        {
            status = true;
            const submitButton = page.querySelector('.w__button--submit');

            if(this.cartItems.length === 0)
            {
                status = false;
            }
            else
            {
                if(document.getElementById('w--cart-empty'))
                {
                    status = false;
                    this.display_cart(false);
                }
                else
                {
                    for(const [key, item] of Object.entries(this.cartItems))
                    {
                        if(item.requireImage === true && !item.uploadedImageSrc)
                        {
                            status = false;
                        }
                    }

                    for(const [key, item] of Object.entries(this.cartExtras))
                    {
                        const myInput = document.getElementById('w--extra-text-' + key);
                        if(myInput)
                        {
                            this.cartExtras[key].requireText = true;
                            this.cartExtras[key].text = myInput.value.trim();

                            myInput.closest('.w__product--extra-container').dataset.chars = myInput.value.trim().length.toString() +
                                '/' + myInput.maxLength.toString();

                            /*if(myInput.value.trim().length === 0)
                            {
                                status = false;
                            }*/
                        }
                        else
                        {
                            this.cartExtras[key].requiredText = false;
                        }
                    }
                }
            }

            if(status === true)
            {
                submitButton.classList.remove('inactive');
            }
            else
            {
                submitButton.classList.add('inactive');
            }

            this.update_session(send,cartKey);
        }

        return status;
    }

    delete_extra(el)
    {
        const extraId = el.dataset.extraId;
        if(this.cartExtras[extraId])
        {
            this.cartExtras[extraId].quantity = 0;
            const quantityEl = el.closest('.w__cart--item').querySelector('.w__input--quantity'),
                  textEl = document.getElementById('w--extra-text-' + extraId);
            quantityEl.value = 0;
            if(textEl)
            {
                textEl.value = '';
            }
            this.update_prices(quantityEl);
        }
    }

    delete_image(key, el)
    {
        Load.post('shop/cart',{
            f: 'cart-delete-image',
            cartKey: key
        }).then(() => {
            this.cartItems[key].uploadedImageSrc = '';
            this.cartItems[key].uploadedThumbSrc = '';

            // if el is given it's a call from function delete_item()
            if(el)
            {
                this.delete_item(el)
            }
            else
            {
                this.display_cart(false);
            }
        }).catch(() => {
            new Modal('Das Bild konnte nicht gelöscht werden.');
        });
    }

    delete_item(el)
    {
        const key = parseInt(el.dataset.cartKey);
        if(this.cartItems[key])
        {
            if(this.cartItems[key].uploadedImageSrc)
            {
                this.delete_image(key, el);
            }
            else
            {
                this.cartItems.splice(key,1);
                this.update_session();
                this.display_cart(false);
            }
        }
    }

    display_cart(addToHistory)
    {
        Load.post(
            'shop/cart',
            {
                f: 'cart',
                action: 'display',
                cart: this.cartItems,
                extras: this.cartExtras
            }).then(r => {
                document.getElementById('w--main').innerHTML = r['html'];
                document.title = r['pageTitle'].replace('&amp;', '&');
                this.check_validity(false);
                if(addToHistory)
                {
                    document.documentElement.scrollTo(0, 0);
                    if(document.location.pathname !== Basic.base + 'shop/cart')
                    {
                        History.push_url(Basic.base + 'shop/cart', r['pageTitle']);
                    }
                }
            }).catch(error => {
                console.error(error);
            });
    }

    edit_cart(key)
    {
        if(this.cartItems[key])
        {
            Load.post(
                'shop/cart',
                {
                    f: 'cart',
                    action: 'edit',
                    cartKey: key,
                    cart: this.cartItems,
                    extras: this.cartExtras
                }).then(r => {
                    document.getElementById('w--main').innerHTML = r['html'];
            }).catch(error => {
                console.error(error);
            })
        }
    }

    update_cartIcon()
    {
        let count = 0;

        this.cartItems.forEach(item => {
            count += item.quantity;
        });

        if(count === 0)
        {
            count = '';
            this.cartIcon.classList.remove('active');
        }
        else
        {
            this.cartIcon.classList.add('active');
        }

        this.cartIcon.dataset.count = count ? count : '';
    }

    update_prices(quantityEl)
    {
        if(quantityEl)
        {
            let key,
                quantity = parseInt(quantityEl.value),
                total = 0;

            // cart extras
            if(quantityEl.dataset.extraId)
            {
                key = quantityEl.dataset.extraId;
                const parentEl = quantityEl.closest('.w__cart--item');
                if(quantity)
                {
                    parentEl.classList.add('active');
                    total = parseFloat(quantityEl.dataset.price);

                    this.cartExtras[key] = {
                        quantity: quantity,
                        label: parentEl.querySelector('.w__cart--item-label').textContent,
                        total: total
                    };
                }
                else
                {
                    parentEl.classList.remove('active');
                    if(key)
                    {
                        delete(this.cartExtras[key]);
                    }
                }
            }
            // cart items
            else
            {
                key = parseInt(quantityEl.dataset.cartKey);
                quantity = parseInt(quantityEl.value);
                if(quantity < 1)
                {
                    quantity = 1;
                }
                else if(quantity > parseInt(quantityEl.max))
                {
                    quantity = parseInt(quantityEl.max);
                }
                this.cartItems[key].quantity = quantity;
                total = this.cartItems[key].total;
            }

            quantityEl.closest('.w__cart--item')
                      .querySelector('.w__cart--product-sum').textContent = Basic.return_price(quantity * total);
            quantityEl.value = quantity.toString();

            this.check_validity(true, quantityEl.dataset.cartKey);
        }

        const totalEl = document.body.querySelector('.w__cart--total-sum');
        if(totalEl)
        {
            let total = 0;
            this.cartItems.forEach(item => {
                total += item.total * item.quantity;
            });

            for(const [key, item] of Object.entries(this.cartExtras))
            {
                total += item.total * item.quantity;
            }

            totalEl.textContent = Basic.return_price(total);
        }
    }

    update_remark(value)
    {
        if(value)
        {
            this.cartExtras['remark'] = {
                label: 'Anmerkung',
                text: value,
                total: 0,
                quantity: 0
            };
        }
        else
        {
            delete this.cartExtras['remark'];
        }
        this.update_session(true);
    }

    update_session(send, cartKey)
    {
        this.update_cartIcon();
        localStorage.setItem("cart", JSON.stringify(this.cartItems));
        localStorage.setItem("extras", JSON.stringify(this.cartExtras));
        if(send === true)
        {
            Load.post(
                'shop/cart',
                {
                    f: 'cart',
                    action: 'update-session',
                    cart: this.cartItems,
                    extras: this.cartExtras,
                    cartKey: (cartKey === undefined) ? null : parseInt(cartKey)
                }).then(r => {
                    // adjust max for all matching items
                    if(cartKey !== undefined &&
                       r['freeContingent'] !== undefined &&
                       r['freeContingent'] !== 99)
                    {
                        const cartContainer = document.body.querySelector('.w__module.mod--cart'),
                              variantId = this.cartItems[cartKey].variantId;
                        if(cartContainer)
                        {
                            const variants = cartContainer.querySelectorAll('.w__input--quantity[data-variant-id="' + variantId + '"]');
                            if(variants.length > 1)
                            {
                                variants.forEach(v =>
                                {
                                    v.max = (r['freeContingent'] + parseInt(v.value)).toString();
                                });
                            }
                        }
                    }
                }).catch(error => {
                    console.error(error);
                });
        }
    }

    process_image(filePicker)
    {
        if(filePicker.files.length > 0) // && this.uploading === false)
        {
            const myFile = filePicker.files[0];
            filePicker.value = '';
            if(!myFile.type.match('(image/(jpeg|jpg|png|gif|bmp|webp))'))
            {
                new Modal("Es können nur Bilder vom Typ JPEG (JPG), PNG, GIF, WEBP oder BMP hochgeladen werden.", true);
            }
            else if(myFile.size/1024/1024 > 20)
            {
                new Modal("Die Datei ist zu groß. Bitte laden Sie Bilder mit weniger als 20 MB hoch.",true);
            }
            else
            {
                this.upload_image(myFile, parseInt(filePicker.dataset.cartKey), filePicker.closest('.w__cart--image-upload'));
            }
        }
    }

    upload_image(myFile, key, parentEl)
    {
        const myReader = new FileReader();
        myReader.addEventListener('load',e =>
        {
            const myImg = new Image;
            myImg.src = e.target.result.toString();

            myImg.addEventListener('load',async () =>
            {
                const width = myImg.width,
                    height = myImg.height;

                if(width < 400 || height < 400)
                {
                    new Modal('Das Bild hat nur ' + width + ' x ' + height +
                        ' Pixel und ist zu klein für den Tortendruck. ' +
                        'Bitte stellen Sie ein Bild in höherer Auflösung bereit.',true);
                }
                else
                {
                    const myModal = new Modal('Das Bild wird hochgeladen:'),
                        imgProgress = myModal.add_textElement('0 %'),
                        prefix = 'user_' + Date.now() + '_';

                    await Load.upload(myFile, prefix, imgProgress);

                    myModal.remove();

                    Load.post('shop/cart', {
                        f: 'verify-upload',
                        prefix: prefix,
                        filename: myFile.name
                    }).then(r =>
                    {
                        this.preview_uploadedImage(r, key, parentEl, myImg.width + ' x ' + myImg.height + ' Pixel / ' +
                            (Math.round(myFile.size / 1024 / 1024 * 100) / 100).toString().replace('.',',') + ' MB');
                    }).catch(() =>
                    {
                        new Modal('Das Bild konnte nicht hochgeladen werden. ' +
                            'Bitte probieren Sie es noch einmal, ggf. mit einer anderen Datei.',true);
                    });
                }
            });
        });
        myReader.readAsDataURL(myFile);
    }

    preview_uploadedImage(r, key, parentEl, imgInfo)
    {
        this.cartItems[key].uploadedImageSrc = r['image'];
        this.cartItems[key].uploadedThumbSrc = r['preview'];
        this.check_validity(true);

        parentEl.innerHTML = '';
        const img = new Image;
        img.src = Basic.base + 'userdata/image-preview/' + r['preview'];
        img.classList.add('w__cart--image-preview');
        parentEl.appendChild(img);

        const uploadInfo = parentEl.closest('.w__cart--item').querySelector('.w__cart--upload-info');
        if(uploadInfo)
        {
            uploadInfo.innerHTML = '<strong>Bildupload erfolgreich</strong><br>' +
                                    imgInfo + '<br>';
            const delButton = document.createElement('button');
            delButton.textContent = 'Bild löschen';
            delButton.classList.add('w__button');
            delButton.classList.add('w__js-button');
            delButton.classList.add('w__cart--button');
            delButton.dataset.f = 'cart-delete-image';
            delButton.dataset.cartKey = key.toString();
            uploadInfo.append(delButton);
        }
    }
}